export default __webpack_public_path__ + "img/bUCYANnb.79d5130c.svg";